import { render, staticRenderFns } from "./HowToConsignmentPage.vue?vue&type=template&id=71b60bf0&scoped=true&"
import script from "./HowToConsignmentPage.vue?vue&type=script&lang=js&"
export * from "./HowToConsignmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b60bf0",
  null
  
)

export default component.exports